export default {"src":"/komodo/_next/static/media/coin_journal.b2509a09.svg","height":59,"width":331,"blurWidth":0,"blurHeight":0};